/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { SupplementalRatesHead } from './TableHead';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

const DisplaySupplementalRates = () => {
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      startQtr: getQuarter,
      suppleRates: getSuppleRates,
    },
  } = useSelector((state) => state?.sharedState?.SupplementalReducer);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [supplementRates, setSupplementRates] = useState();
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // supplemental rates data
  React.useEffect(() => {
    let data = getSuppleRates?.supplementalRatesReportVO;
    data = data?.map((item) => {
      return {
        ...item,
        ampEstimationInd: item.ampEstimationInd
          ? item.ampEstimationInd?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
            })
          : '0.00',
        calcUra: item.calcUra
          ? `$ ${item.calcUra?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
            })}`
          : '$0.00',
        gnupAmt: item.gnupAmt
          ? `$ ${item.gnupAmt?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
            })}`
          : '$0.00',
        cmsUraUsed: item.cmsUraUsed ? item.cmsUraUsed.toFixed(4) : '0.0000',
        ampPriceAmt: item.ampPriceAmt ? item.ampPriceAmt.toFixed(4) : '0.0000',
        // ? '$' +
        //   item.ampPriceAmt?.toLocaleString('en-US', {
        //     minimumFractionDigits: 2,
        //   })
        // : '$0.00',
        totalRebatePct: item.totalRebatePct
          ? `${item.totalRebatePct?.toLocaleString('en-US', {
              minimumFractionDigits: 2,
            })}%`
          : '0.00%',
      };
    });
    setSupplementRates(data);
  }, [getSuppleRates]);

  // pdf header
  const secondInfo = `Quarter: ${getQuarter}`;
  const thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;
  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display Supplemental Rates"
      />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Quarter"
                        id="Quarter1"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Quarter1' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={getQuarter}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGridWithFeatures
            data-testid="Supplemental-Rates-Report"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={supplementRates}
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            columnDefs={SupplementalRatesHead}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
            reportName="Supplemental Rates Report"
            fileName="Supplemental Rates Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            info={{ secondInfo, thirdInfo }}
          />
        </div>
      </div>
    </div>
  );
};

export default DisplaySupplementalRates;
